<template>

  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <img class="logo_sportips" src="https://sportips.fr/images/Sportips_Logo_Horizontal_RVB.png" alt="" />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!-- Paiement -->
        <div class="pa-4 rounded elevation-1 bg-grey_1" v-if="!has_preinscription">
          <p class="text-center" v-if="transaction && transaction.commande_infos">
            <span v-if="transaction.commande_infos.amount > 0">Votre paiement de la commande {{
              transaction.commande_infos.orderId }} pour un montant de {{ transaction.commande_infos.amount / 100 }}
              euros est accepté.</span>
            <span v-else>Votre inscription est validée.</span>
          </p>
          <p class="text-center" v-else>Notre système à déjà enregistré un paiement pour cette commande.<br /></p>
          <p class="text-center" v-if="has_accueil_qrcode && urls_billets && urls_billets.length > 0">Vous allez
            recevoir un mail de confirmation de commande ainsi que vos billets dans quelques instants (pensez à
            vérifier vos spams)</p>
          <p class="text-center" v-else>Vous allez recevoir un mail de confirmation dans quelques instants (pensez à
            vérifier vos spams)</p>

          <div class="mb-3" v-if="has_accueil_qrcode && urls_billets && urls_billets.length > 0">
            <p class="text-center">Vous pouvez aussi télécharger vos billets en cliquant sur les liens ci-dessous :
            </p>
            <div class="d-flex justify-center gap">
              <a v-for="(link_ticket, index) in urls_billets" :key="index"
                :href="'https://sportips.fr/api/v2/endpoints/billet/get.php?id_inscription=' + link_ticket.id_inscription"
                target="_blank"><v-btn color="primary-dark">{{ link_ticket.recipient }}</v-btn></a>
            </div>
            <v-divider></v-divider>
          </div>

          <div class="d-flex justify-center gap">
            <router-link :to="{ name: 'FicheCoureur' }"><v-btn variant="outlined" color="primary-dark">Accèder ma
                fiche</v-btn></router-link>
            <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à l'accueil</v-btn></router-link>
          </div>
        </div>
        <!-- Preinscription -->
        <div class="pa-4 rounded elevation-1 bg-grey_1" v-else>
          <p class="text-center" v-if="transaction && transaction.commande_infos">Votre pré-paiement de la commande {{
            transaction.commande_infos.orderId }} pour un montant de {{ transaction.commande_infos.amount / 100 }}
            euros est accepté.<br /></p>
          <p class="text-center" v-else>Notre système à déjà enregistré un pré-paiement pour cette commande.<br /></p>

          <p class="text-center">Vous allez recevoir un mail de confirmation dans quelques instants (pensez à
            vérifier vos spams)</p>
          <p class="text-center">Aucune action supplémentaire n'est nécessaire de votre part. Votre pré-inscription est
            validée.</p>



          <div class="d-flex justify-center gap">
            <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à l'accueil</v-btn></router-link>
          </div>
        </div>

      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import { useAmendBookingStore } from "@/stores/amendBookingStore";
import UserService from '@/services/user.service';
export default {
  data() {
    return {
      transaction: {},
      order_id: "",
      urls_billets: [],
      has_made_preinscription: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore, useAmendBookingStore),
    has_accueil_qrcode() {
      return this.mainStore.module.has_accueil_qr_code;
    },
    has_preinscription() {
      return this.mainStore.module.has_preinscription || this.has_made_preinscription;
    },
  },
  async created() {
    if (!this.bookingStore.id_module) {
      this.$router.push({ name: "Home" });
    }
    if (this.bookingStore.transaction) {
      this.transaction = JSON.parse(JSON.stringify(this.bookingStore.transaction));
    }
    if (this.has_accueil_qrcode) {
      this.urls_billets = await UserService.getUrlsBillets(this.transaction);
    }

    this.has_made_preinscription = JSON.parse(JSON.stringify(this.bookingStore.has_at_least_one_preinscription_selected));
    this.bookingStore.clearState();
    this.mainStore.bookingSystem.groupe.clearState();
    this.bookingStore.clearLocalStorage();

    this.amendBookingStore.clearState();
  },
};
</script>

<style lang="scss" scoped></style>